<template>
	<span
		class="appointment-icon"
		:style="{ width: `${size}px`, height: `${size}px` }"
		aria-hidden="true"
		v-html="icons[`../../assets/icons/appointments/${name}.svg`]"
	></span>
</template>

<script>
// Only trusted, bundled SVG files are rendered here; names cannot load external markup.
const icons = import.meta.glob('../../assets/icons/appointments/*.svg', {
	eager: true,
	query: '?raw',
	import: 'default',
});
</script>

<script setup>
defineProps({
	name: {
		type: String,
		required: true,
		validator: (name) => Object.hasOwn(icons, `../../assets/icons/appointments/${name}.svg`),
	},
	size: { type: Number, default: 18 },
});
</script>

<style scoped>
.appointment-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: none;
	vertical-align: middle;
	line-height: 0;
	pointer-events: none;
}

.appointment-icon :deep(svg) {
	display: block;
	width: 100%;
	height: 100%;
}
</style>
